import React from 'react';
import classNames from 'classnames';
import tinycolor from 'tinycolor2';
import styles from './sections.module.scss';

const HeroSection = ({
  background,
  navBackground,
  colors,
  logoUrl,
  corporationName,
  headline,
  subtitle,
  headlineAlignment = 'Left',
  onViewOpportunities,
  onContact,
  mobileLayout = false
}) => {
  const isNavDark = tinycolor(navBackground).isDark();

  return (
    <section
      className={classNames(styles.hero, mobileLayout && styles.heroMobile)}
      style={{ background, color: colors.heroText }}
    >
      <nav className={styles.nav} style={{ background: navBackground }}>
        <div className={styles.navContainer}>
          {logoUrl && (
            <div className={styles.navLogo}>
              <img
                src={logoUrl}
                alt={corporationName || 'Company logo'}
                className={classNames(styles.logo, isNavDark ? styles.logoOnDark : styles.logoOnLight)}
              />
            </div>
          )}
          <div className={styles.navActions}>
            <button
              type="button"
              className={classNames(styles.btnPrimary, styles.btnPrimaryNav)}
              style={{ background: colors.accent }}
              onClick={onViewOpportunities}
            >
              VIEW OPPORTUNITIES
            </button>
            <button
              type="button"
              className={classNames(styles.btnOutlineWhite, styles.btnOutlineWhiteNav)}
              onClick={onContact}
            >
              HAVE QUESTIONS?
            </button>
          </div>
        </div>
      </nav>
      <div className={styles.container}>
        <div className={styles.heroContent}>
          <div className={classNames(styles.heroText, styles[`heroAlign${headlineAlignment.toLowerCase()}`])}>
            <p className={styles.sectionLabel}>JOIN OUR TEAM</p>
            {(headline.main || headline.accent) && (
              <h1 className={styles.heroHeading} style={{ color: colors.heroText }}>
                {headline.main}
                {headline.accent && (
                  <>
                    <br />
                    <span className={styles.accent} style={{ color: colors.heroAccent }}>
                      {headline.accent}
                    </span>
                  </>
                )}
              </h1>
            )}
            {subtitle && <p className={styles.heroSubtitle}>{subtitle}</p>}
            <div className={styles.heroCtas}>
              <button
                type="button"
                className={classNames(styles.btnPrimary, styles.btnPrimaryHero)}
                style={{ background: colors.accent }}
                onClick={onViewOpportunities}
              >
                VIEW OPPORTUNITIES
              </button>
              <button
                type="button"
                className={classNames(styles.btnOutlineWhite, styles.btnOutlineWhiteHero)}
                onClick={onContact}
              >
                HAVE QUESTIONS?
              </button>
            </div>
          </div>
          <div className={styles.heroImage}>
            <img
              className={styles.heroAgent}
              src="/static/img/webpage/recruit-hero-agent.png"
              alt="Insurance Professional"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
